













import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class FbShareButton extends Vue {
  @Prop({ required: true }) url: string;
  mounted() {
    setTimeout(() => {
      const fbAsyncInit = (window as any).fbAsyncInit;
      if (fbAsyncInit) {
        fbAsyncInit();
      }
    }, 100);
  }
}
